export const sortByExpiryDate = <T extends { expiryDate?: string | null }>(
    items: T[],
): T[] => {
    return [...items].sort((a, b) => {
        if (!a.expiryDate && !b.expiryDate) return 0;
        if (!a.expiryDate) return 1;
        if (!b.expiryDate) return -1;
        
        // Assumes expiryDate is in ISO format (YYYY-MM-DD) or sortable string format
        return a.expiryDate < b.expiryDate ? -1 : a.expiryDate > b.expiryDate ? 1 : 0;
    });
};
